import { buildParams, CoreAPI } from '../../../Services/CoreAPI'

export const obtainGenreByFilter = async (filter) => {
  let endpoint = '/v1/genre'

  if (filter) {
    const params = buildParams(filter)
    endpoint = `/v1/genre?${params.toString()}`
  }

  const resp = await CoreAPI.get(endpoint)

  const {
    data: list = [],
    pagination: { totalPages = 1 } = {}
  } = resp

  if (list?.data) {
    return { list: list.data, totalPages }
  } else {
    return { list, totalPages }
  }
}

export const obtainGenreById = async (genreId) => {
  const endpoint = `/v1/genre/${genreId}`
  const resp = await CoreAPI.get(endpoint)

  if (resp.data?.data) {
    return resp.data.data
  }

  return resp.data
}

export const createGenre = async (data) => {
  const endpoint = '/v1/genre'
  const resp = await CoreAPI.post(endpoint, data)
  return resp.data
}

export const updateGenre = async (genreId, data) => {
  const endpoint = `/v1/genre/${genreId}`
  const resp = await CoreAPI.put(endpoint, data)
  return resp.data
}

export const deleteGenre = async (genreId) => {
  const endpoint = `/v1/genre/${genreId}`
  const resp = await CoreAPI.delete(endpoint)
  return resp.data
}
